import * as React from "react";
import { Card, CardContent, CardHeader } from '@material-ui/core';

// eslint-disable-next-line
export default () => {
    return(
        <Card>
            <CardHeader title="Панель управления системой телеметрии" />
            <CardContent>Когда-нибудь тут будут очень красивые графики...</CardContent>
        </Card>
    )
}